
export default {
  "hero.title": "Industrial Knitting",
  "hero.subtitle": "ー未来を編む・価値を紡ぐー",
  "hero.description": "機能を製品に編み込む革新的な技術。従来の塗装や外装材を超える、新しい製造の時代を発見してください。",
  "hero.cta": "詳しく見る",
  
  "about.title": "私たちのビジョン",
  'about.subtitle': 'インダストリアル・ニットが拓く、新たなデザインと機能の地平',
  "about.description": "私たちは、工業製品の開発支援で培った技術をもとに、2022年、アパレルという新たな領域に挑戦し、ブランド「ritsu」を立ち上げました。デザインから製造・販売までを自ら手がける中で、ニット素材が持つ柔軟性と立体的な表現力に魅了されました。その可能性を工業製品へと応用することで、機能性と価値表現を両立する新たなソリューションを生み出しました。この“アパレルへの挑戦”こそが、インダストリアルニットのコア技術なのです。",
  
  "portfolio.title": "Use Case",
  "portfolio.subtitle": "インダストリアル・ニッティングの無限の可能性",
  "portfolio.description": "これまでのプロダクトデザインでは、塗装や外装材によって表情をつくるのが当たり前でした。しかし、インダストリアル・ニッティングはその常識を覆します。「プロダクトが服を着る」という新しい発想。塗装レスで機能を\"編み込み\"、カスタムデザインや用途に応じて柔軟に形を変える、これまでの表現では到達できなかった多様性を実現するソリューションです。",
  
  "services.title": "Technology",
  "services.subtitle": "最新のテクノロジーと豊富な経験を活かし、お客様のビジネスを次のレベルへと導きます",
  "services.item1.title": "塗装レスデザイン",
  "services.item1.description": "塗装工程を排除した環境に優しい製造",
  "services.item2.title": "機能統合",
  "services.item2.description": "複数の機能を単一の素材に編み込む",
  "services.item3.title": "カスタム柔軟性",
  "services.item3.description": "多様なデザインと用途に柔軟に対応",
  
  "core.title": "Core Technology",
  "core.subtitle": "伝統と技術の融合から生まれるイノベーション",
  "core.item1.title": "3Dニッティング技術",
  "core.item1.description": "編み込みによって立体形状を創り出す先進技術",
  "core.item2.title": "素材開発",
  "core.item2.description": "機能性とデザイン性を兼ね備えた新素材の開発",
  "core.item3.title": "デジタルデザイン",
  "core.item3.description": "最新のCAD/CAMシステムを活用した精密設計",
  
  "contact.title": "Contact Us",
  "contact.subtitle": "プロジェクトのご相談やお見積もりなど、お気軽にお問い合わせください",
  "contact.contactInfo": "お問い合わせ先",
  "contact.address": "所在地",
  contactAddress: '所在地',
  contactAddressValue: '〒252-1125\n神奈川県綾瀬市吉岡東1-14-13',
  "contact.phone": "電話番号",
  "contact.emailLabel": "メール",
  "contact.businessHours": "営業時間",
  "contact.businessHoursDetail": "平日 8:30 - 17:30",
  "contact.businessHoursClosed": "（土日祝日は休業）",
  "contact.phoneNumber": "0467-78-8891 （代表）",
  "contact.step": "ステップ",
  "contact.basicInfo": "基本情報",
  "contact.name": "お名前",
  "contact.namePlaceholder": "山田太郎",
  "contact.email": "メールアドレス",
  "contact.emailPlaceholder": "example@email.com",
  "contact.company": "会社名",
  "contact.companyPlaceholder": "株式会社サンプル",
  "contact.next": "次へ",
  "contact.back": "戻る",
  "contact.serviceInterest": "ご興味のあるサービス",
  "contact.serviceInterestDesc": "該当するサービスを選択してください",
  "contact.service1": "サンプル素材製作",
  "contact.service2": "デザイン試作",
  "contact.service3": "デザインコンサルティング",
  "contact.service4": "商品企画／開発",
  "contact.service5": "その他",
  "contact.projectScale": "プロジェクトの規模",
  "contact.projectScaleDesc": "想定されるプロジェクトの規模を選択してください",
  "contact.scale1": "小規模（1-2ヶ月程度）",
  "contact.scale2": "中規模（3-6ヶ月程度）",
  "contact.scale3": "大規模（6ヶ月以上）",
  "contact.scale4": "未定・相談したい",
  "contact.startTiming": "希望開始時期",
  "contact.startTimingDesc": "プロジェクトの開始時期を選択してください",
  "contact.timing1": "すぐに開始したい",
  "contact.timing2": "1ヶ月以内",
  "contact.timing3": "2-3ヶ月以内",
  "contact.timing4": "3ヶ月以降",
  "contact.timing5": "未定・相談したい",
  "contact.budget": "予算感",
  "contact.budgetDesc": "想定されている予算を選択してください",
  "contact.budget1": "50万円未満",
  "contact.budget2": "50万円〜100万円",
  "contact.budget3": "100万円〜300万円",
  "contact.budget4": "300万円以上",
  "contact.budget5": "未定・相談したい",
  "contact.detailMessage": "詳細メッセージ（任意）",
  "contact.detailMessageDesc": "追加でお伝えしたいことがあればご記入ください",
  "contact.messagePlaceholder": "プロジェクトの詳細やご質問をお聞かせください",
  "contact.characters": "文字",
  "contact.toConfirm": "確認画面へ",
  "contact.confirmInput": "入力内容の確認",
  "contact.edit": "修正する",
  "contact.send": "送信する",
  "contact.sending": "送信中...",
  "contact.submitSuccess": "送信完了",
  "contact.submitSuccessMessage": "お問い合わせありがとうございます.\n担当者より折り返しご連絡させていただきます。",
  "contact.newInquiry": "新規お問い合わせ",
  "contact.submitError": "送信に失敗しました",
  "contact.submitErrorMessage": "もう一度お試しいただくか、お電話にてお問い合わせください。",
  "contact.message": "メッセージ",
  "contact.success": "メッセージが正常に送信されました！",
  
  "footer.rights": "All rights reserved.",
  "footer.link": "Website Builder",
  "footer.companyName": "株式会社日南",
  "footer.companyDescription": "革新的なニッティング技術で、未来のものづくりを創造します。",
  "footer.servicesTitle": "サービス",
  "footer.service1": "インダストリーニット",
  "footer.service2": "アパレルブランド【ritsu】",
  "footer.service3": "デザイン開発",
  "footer.service4": "各種プロトタイピング",
  "footer.companyInfoTitle": "会社情報",
  "footer.companyNameLabel": "社名：株式会社日南",
  "footer.postalCode": "〒252-1125",
  "footer.address": "神奈川県綾瀬市吉岡東1-14-13",
  "footer.tel": "TEL：0467-78-8891",
  "footer.fax": "FAX：0467-78-8895",
  "footer.copyright": "© 2024 株式会社日南. All rights reserved.",
  "footer.privacyPolicy": "プライバシーポリシー",
  "footer.termsOfService": "利用規約",
  
  'coreTech.title': 'コア技術',
  'Industrial Knit – Design Woven with Intelligence1': 'Industrial Knit –',
  'Industrial Knit – Design Woven with Intelligence2': 'Design Woven with Intelligence',
  'coreTech.tagline2': '機能をデザインする ー',
  'coreTech.paragraph1': '私たちは工業製品の開発支援で培った技術をもとに、2022年からアパレルという新たな領域に挑戦しました。工業製品の開発支援で培った精密な技術に、アパレル分野で得た創造性とネットワークを融合させました。デザインから製造、販売までを自ら経験する中で培われた"素材と構造を一体でデザインする力"――その実践知こそが、インダストリーニットの原点です。',
  'coreTech.paragraph2': '服をデザインし、製造・販売までを自ら手がける中で、試行錯誤を重ねるうちに、素材と構造の融合が生み出す\"新たな表現方法\"にたどり着きました。フルカラー3Dプリントを応用したアクセサリーデザイン、そしてニットという柔軟で立体的な表現手法との出会いを経て、機能性と造形美を兼備えた新たなソリューション、「インダストリーニット」が誕生しました。',
  'coreTech.paragraph3': 'アパレルの感性と工業デザインの精密さが融合した、まったく新しいクリエイティブソリューションです。',
  'coreTech.companyDescription': '私たちは、工業製品の開発支援で培った技術をもとに、2022年、アパレルという新たな領域に挑戦し、ブランド「ritsu」を立ち上げました。デザインから製造・販売までを自ら手がける中で、ニット素材が持つ柔軟性と立体的な表現力に魅了されました。その可能性を工業製品へと応用することで、機能性と価値表現を両立する新たなソリューションを生み出しました。この“アパレルへの挑戦”こそが、インダストリアルニットのコア技術なのです。',
  'coreTech.viewDetails': '詳細を見る',
  
  aboutTitle: '私たちのビジョン',
  aboutSubtitle: 'インダストリアル・ニットが拓く、新たなデザインと機能の地平',
  aboutCompanyDescription: '私たちは、工業製品の開発支援で培った技術をもとに、2022年、アパレルという新たな領域に挑戦し、ブランド「ritsu」を立ち上げました。デザインから製造・販売までを自ら手がける中で、ニット素材が持つ柔軟性と立体的な表現力に魅了されました。その可能性を工業製品へと応用することで、機能性と価値表現を両立する新たなソリューションを生み出しました。この“アパレルへの挑戦”こそが、インダストリアルニットのコア技術なのです。',
  aboutViewDetails: '詳細を見る',

  'aboutStory.description': '塗装で装う時代から、編み地でまとう時代へ。インダストリアル・ニッティングは、「プロダクトが服を着る」という発想で、表現の限界を超える新たな多様性を生み出します。',
  'aboutStory.item1.title': '着替えるプロダクト、変わる気分',
  'aboutStory.item1.description': 'プロダクトが服を着るように、暮らしも気分で変わる。季節や光の移ろいに合わせて"着替える"ことで、空間はまるで呼吸するように表情を変える。編み地の温もりが心を包み、使うほどに愛着が増していく。そんな"生きているプロダクト"が、日常に穏やかなリズムを奏でます。',
  'aboutStory.item2.title': '機能 × デザイン × サステナビリティ',
  'aboutStory.item2.description': '編むことで生まれる機能とデザインの融合。インダストリアル・ニットは、構造そのものを美しく仕立て、強さ・しなやかさ・やさしさを兼ね備えた、サステナブルなものづくりを実現します。長く使うほどに愛着が深まり、使う人の暮らしに寄り添い続けます。',
  'aboutStory.item3.title': '多様な産業へ広がる応用領域',
  'aboutStory.item3.description': '「表皮」の概念をアップデートします。それは単なる覆いではなく、機能を内包し、感性をまとう"生きたスキン"。医療・ロボティクス・プロダクトデザインなど、多様な分野で"編む"という発想が構造とデザインを再定義し、産業の境界を超えて進化を導いています。',
  
  'portfolio.item1.title': 'オートモーティブ',
  'portfolio.item1.subtitle': 'センサーを織り込んだファブリック、照明が透過するファブリック、プロジェクションマッピングが美しく映るインストロメンタルパネル',
  'portfolio.item1.tag1': '空間デザイン',
  'portfolio.item1.tag2': 'スマートファブリック',
  'portfolio.item1.tag3': 'インタラクティブ',
  'portfolio.item1.description': 'インダストリアル・ニッティング技術を活用した革新的な空間デザイン。センサーを織り込んだスマートファブリック、光を透過する特殊ニット素材、プロジェクションマッピングに最適化されたインストロメンタルパネルなど、従来の空間概念を覆す新しいデザインソリューションを提供します。',
  'portfolio.item1.feature1': 'センサー内蔵スマートファブリックの開発',
  'portfolio.item1.feature2': '光透過性ニット素材による照明システム',
  'portfolio.item1.feature3': 'プロジェクションマッピング対応パネル設計',
  'portfolio.item1.feature4': 'インタラクティブな空間体験の創出',
  'portfolio.item1.feature5': '環境に応じた動的デザイン変化機能',
  'portfolio.item1.result1': '空間の快適性と感性価値の向上',
  'portfolio.item1.result2': 'テクノロジーによる表現の自由の拡張',
  'portfolio.item1.result3': '人と空間をつなぐインタラクティブな体験の創出',
  'portfolio.item1.result4': '機能と造形が調和するしなやかなデザイン進化',
  'portfolio.item1.result5': 'サステナブルな素材発想による新たな価値創造',
  
  'portfolio.item2.title': 'プロダクト',
  'portfolio.item2.subtitle': 'ニットの服を着るプロダクトデザイン。従来の硬いシェルから柔らかいスキンへの転換',
  'portfolio.item2.tag1': 'プロダクトデザイン',
  'portfolio.item2.tag2': 'ニットスキン',
  'portfolio.item2.tag3': 'サステナブル',
  'portfolio.item2.description': 'プロダクトが「服を着る」という革新的なデザインアプローチ。従来の硬いプラスチックシェルや金属筐体を、機能的で美しいニットスキンに置き換えることで、触感・デザイン性・環境性能を同時に向上させる新しいプロダクトデザインソリューションです。',
  'portfolio.item2.feature1': 'ニットスキンによる柔らかな触感の実現',
  'portfolio.item2.feature2': '塗装レスでカラーバリエーション対応',
  'portfolio.item2.feature3': 'カスタマイズ可能なテクスチャデザイン',
  'portfolio.item2.feature4': '軽量化と耐久性の両立',
  'portfolio.item2.feature5': 'リサイクル可能な素材構成',
  'portfolio.item2.result1': 'プロダクトに生命感と個性を与えるデザイン表現',
  'portfolio.item2.result2': '素材がもたらす触感と温度感による体験価値の向上',
  'portfolio.item2.result3': 'プロダクトと空間をつなぐ、新しいインテリアのかたち',
  'portfolio.item2.result4': '愛着が深まる、感性を刺激するプロダクト体験',
  'portfolio.item2.result5': 'サスティナブルな次世代のものづくりモデル',
  
  'portfolio.item3.title': 'インテリア',
  'portfolio.item3.subtitle': '植木鉢から照明、ソファまで着替えることで気分をリフレッシュ！',
  'portfolio.item3.tag1': 'インテリアデザイン',
  'portfolio.item3.tag2': 'ニットカバー',
  'portfolio.item3.tag3': 'リフレッシュ',
  'portfolio.item3.description': 'インテリア空間に「着替える」という新しい概念を導入。植木鉢、照明器具、ソファなど、あらゆるインテリアアイテムがニットの「服」を着ることで、季節や気分に合わせて空間の表情を自由に変えることができる革新的なインテリアソリューションです。',
  'portfolio.item3.feature1': '植木鉢用ニットカバーシステム',
  'portfolio.item3.feature2': '照明器具の着せ替えニットシェード',
  'portfolio.item3.feature3': 'ソファ・チェア用カスタムニットカバー',
  'portfolio.item3.feature4': '季節に応じたテクスチャ・カラー変更',
  'portfolio.item3.feature5': '取り外し可能な機能的ニット装飾',
  'portfolio.item3.result1': '空間の印象を自在に変えられる柔軟性',
  'portfolio.item3.result2': '温もりと触感による快適な体験価値',
  'portfolio.item3.result3': '季節に対応した楽しさを提供',
  'portfolio.item3.result4': 'サステナブルな暮らしの提案',
  'portfolio.item3.result5': 'プロダクトと空間をつなぐ、新しいインテリアのかたち',
  
  'portfolio.item4.title': 'ロボテックス',
  'portfolio.item4.subtitle': 'ロボットが着るニットスキン。機械的な外観から親しみやすい存在への変革',
  'portfolio.item4.tag1': 'ロボティクス',
  'portfolio.item4.tag2': 'ニットスキン',
  'portfolio.item4.tag3': 'ヒューマンフレンドリー',
  'portfolio.item4.description': 'ロボティクス分野における革新的なアプローチとして、従来の冷たく機械的な外観を持つロボットに「ニットスキン」を着せることで、人間にとってより親しみやすく、温かみのある存在に変革します。機能性と感情的な親和性を両立させた次世代ロボットデザインソリューションです。',
  'portfolio.item4.feature1': 'ロボット用ニットスキンカバーシステム',
  'portfolio.item4.feature2': '触感による親和性向上機能',
  'portfolio.item4.feature3': '表情豊かなテキストデザイン',
  'portfolio.item4.feature4': 'メンテナンス性を考慮した着脱システム',
  'portfolio.item4.feature5': '環境に応じたスキン変更機能',
  'portfolio.item4.result1': 'ユーザー親和性向上',
  'portfolio.item4.result2': 'ロボット受容度改善',
  'portfolio.item4.result3': '安全性認識の向上',
  'portfolio.item4.result4': 'メンティス効率の改善',
  'portfolio.item4.result5': 'オンデマンド生産対応',
  
  'portfolio.item5.title': 'ウエラブル',
  'portfolio.item5.subtitle': 'ウェアラブルデバイスから医療機器まで、人に寄り添うニットスキンで医療体験を革新',
  'portfolio.item5.tag1': 'ヘルステック',
  'portfolio.item5.tag2': 'ウェアラブル',
  'portfolio.item5.tag3': 'メディカル',
  'portfolio.item5.description': '身にまとうデータプラットフォームという新たな社会インフラを構築する可能性を持ちます。それは単なる衣服の進化ではなく、人間の生体情報と感性を結ぶ「第二の皮膚」としての価値を備えています。',
  'portfolio.item5.feature1': 'ウェアラブルデバイス用ニットスキンカバー',
  'portfolio.item5.feature2': '医療機器の患者接触面ニット化',
  'portfolio.item5.feature3': '抗菌・防臭機能を織り込んだ医療用ファブリック',
  'portfolio.item5.feature4': '生体センサー内蔵スマートニット素材',
  'portfolio.item5.feature5': '患者の心理的負担軽減デザイン',
  'portfolio.item5.result1': 'センサーなどのインテグレーション性能',
  'portfolio.item5.result2': '機能とデザインの融合',
  'portfolio.item5.result3': 'ウェアラブル装着性能の最適化',
  'portfolio.item5.result4': 'デザインの自由度拡大',
  'portfolio.item5.result5': '装着性の向上',
  
  'portfolio.item6.title': 'ヘルステック',
  'portfolio.item6.subtitle': 'サポーターやコルセットなどの医療用具に革新的なニット技術を応用',
  'portfolio.item6.tag1': 'メディカル',
  'portfolio.item6.tag2': 'サポーター',
  'portfolio.item6.tag3': 'リハビリテーション',
  'portfolio.item6.description': '従来の硬く不快な医療用サポーターやコルセットを、インダストリアル・ニッティング技術で革新。患者の快適性を大幅に向上させながら、必要な医療効果を確実に提供する次世代医療用具を開発しています。',
  'portfolio.item6.feature1': '3Dニッティングによるオーダーメイドサポーター',
  'portfolio.item6.feature2': '段階的圧迫機能を織り込んだコルセット',
  'portfolio.item6.feature3': '通気性と保温性を両立した医療用ニット',
  'portfolio.item6.feature4': 'センサー内蔵によるリハビリ進捗モニタリング',
  'portfolio.item6.feature5': '洗濯可能で衛生的な医療用テキスタイル',
  'portfolio.item6.result1': '患者の装着快適性の向上',
  'portfolio.item6.result2': '治療効果の持続性の改善',
  'portfolio.item6.result3': '医療費削減効果',
  'portfolio.item6.result4': 'リハビリ継続率の向上',
  'portfolio.item6.result5': '医療従事者の負担軽減',
  
  'portfolio.modal.projectImages': 'プロジェクト画像',
  'portfolio.modal.projectOverview': 'プロジェクト概要',
  'portfolio.modal.mainFeatures': '主な機能',
  'portfolio.modal.technologies': '使用技術',
  'portfolio.modal.results': '成果・効果',
  'portfolio.modal.close': '閉じる',
  'portfolio.modal.imageEditor': '画像エディター',
  'portfolio.modal.adjustments': '調整',
  'portfolio.modal.brightness': '明度',
  'portfolio.modal.contrast': 'コントラスト',
  'portfolio.modal.saturation': '彩度',
  'portfolio.modal.rotation': '回転',
  'portfolio.modal.scale': 'スケール',
  'portfolio.modal.quickAdjust': 'クイック調整',
  'portfolio.modal.rotateLeft': '左回転',
  'portfolio.modal.rotateRight': '右回転',
  'portfolio.modal.zoomIn': '拡大',
  'portfolio.modal.zoomOut': '縮小',
  'portfolio.modal.reset': 'リセット',
  'portfolio.modal.save': '保存',
  
  'services.innovation.title': 'イノベーション',
  'services.innovation.description': '長年にわたり培われた職人の知見と感性を、AIが学び、拡張する。人とAIが共に創り上げたワークフローが、自然言語からリアルタイムでソースコードを生成し、編地データを瞬時に構築します。職人の手仕事の精度と、AIのスピードが融合することで、色彩・立体構造・機能が自由に交差し、かつてない表現の可能性が広がります。クラフトマンシップとテクノロジーが共鳴することで誕生した、それが未来のワークフローです。',
  'services.designTeam.title': 'デザインチーム',
  'services.designTeam.description': 'クロスファンクショナルチーム：デザイナー、モデラー、ニッティングのエキスパートが一つのチームとなり、ニッティングの基礎を学び、長年の試行錯誤で培った製造技術と融合。その過程で培われた創造性と技術が融合し、新しい概念「インダストリアルニット」が生まれました。',
  'services.viewDetails': '詳細を見る',
  'services.service1.link': 'Workflow',
  'services.service2.link': 'Creative Team',
};
